import type { ButtonHTMLAttributes, ReactNode } from 'react'

import type { IconType } from 'components/icons'
import type { IconSizes } from 'theme/theme'

import { Button as StyledButton } from './styles'

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean
  icon: IconType | null
  title: string
  iconSize?: IconSizes
  children?: ReactNode
}

export const IconButton = ({
  icon: Icon,
  iconSize = 'medium',
  children,
  ...rest
}: IconButtonProps) => (
  <StyledButton {...rest}>
    {Icon && <Icon size={iconSize} />}
    <span>{children}</span>
  </StyledButton>
)
